import { z } from 'zod';
import { CreateAddressInputDTOSchema } from "../../../addresses/index.js";
import { BasePersonDTOSchema } from "./persons.dto.js";
// Schema for input validation when updating a person
export const UpdatePersonInputDTOSchema = BasePersonDTOSchema.omit({
    celcoinId: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
});
// Action layer DTOs (with address and company context).
// Address uses the create-shape: there is no client-known address id — when an
// address already exists for the person, the action resolves the id internally.
const UpdatePersonActionInputDTOSchema = UpdatePersonInputDTOSchema.extend({
    address: CreateAddressInputDTOSchema.nullable(),
    companyId: z.uuid(),
});
// Request and response schemas for the API layer
export const UpdatePersonRequestDTOSchema = z.object({
    body: UpdatePersonActionInputDTOSchema.omit({
        id: true,
        companyId: true,
    }),
    params: z.object({
        companyId: z.uuid(),
        personId: z.uuid(),
    }),
});
//# sourceMappingURL=update-person.dto.js.map